import AOS from 'aos';

AOS.init({
    useClassNames: true,
    initClassName: false,
    animatedClassName: 'aos'
});

var rellax = new Rellax('.rellax');